module.exports = __webpack_public_path__ + "img/27.77b0326e.png";